import FindSuccess from '../../../../components/Auth/FindSuccess';
import '../FindAuthForm.css';
import '../find.css';

const FindSuccessPage = () => {
    return (
        <div className="findPage">
            <FindSuccess />
        </div>
    );
};

export default FindSuccessPage;
